/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tasks_Category_PatrolInputs */

const en_tasks_category_patrol = /** @type {(inputs: Tasks_Category_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrol`)
};

const fr_tasks_category_patrol = /** @type {(inputs: Tasks_Category_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Patrouille`)
};

const ms_sg2_tasks_category_patrol = /** @type {(inputs: Tasks_Category_PatrolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rondaan`)
};

/**
* | output |
* | --- |
* | "Patrol" |
*
* @param {Tasks_Category_PatrolInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const tasks_category_patrol = /** @type {((inputs?: Tasks_Category_PatrolInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tasks_Category_PatrolInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tasks_category_patrol(inputs)
	if (locale === "fr") return fr_tasks_category_patrol(inputs)
	return ms_sg2_tasks_category_patrol(inputs)
});